import { SuperScript } from '@/components/cohort/SuperScript';
import { Segment } from '../../components/cohort/HowDoI/HowDoI';

export const SavingsContent: Segment = {
  header: 'Pay down my home loan faster',
  imageUrl: '/next-assets/images/cohort/athena-savings-superpower.svg',
  imageAlt: "ATHENA'S SAVINGS SUPERPOWERS",
  gridContent: [
    {
      title: 'No fee loans',
      description: (
        <span>
          Choose an Athena loan with no fees and avoid paying an average of $8,650 in fees with other lenders
          <SuperScript>4</SuperScript>. Pay your loan off faster instead!
        </span>
      ),
    },
    {
      title: 'Drop your own rate',
      description: (
        <span>
          With AcceleRATES the more you pay down your loan, the more we&apos;ll lower your interest rate - automatically
          <SuperScript>2</SuperScript>.
        </span>
      ),
    },
    {
      title: "Don't pay loyalty tax",
      description: (
        <span>
          Loyalty tax is when existing customers are charged a higher interest rate than new customers. UNFAIR. All
          customers get the same great rate on like-for-like loans
          <SuperScript>3</SuperScript> at Athena.
        </span>
      ),
    },
    {
      title: 'Offset and save',
      description:
        'Pay less interest by salary crediting into your offset. Set up multiple offsets to help bucket savings goals.',
    },
  ],
  quote: {
    author: 'Marion, Home Loan Wrecker',
    quote: `"We're now saving a lot with our new loan! I simply
      can't find a better home loan package than Athena's
      for paying off my mortgage sooner."`,
    isTrustPilot: true,
  },
};

export const PayLessContent: Segment = {
  header: 'Pay less on my home loan',
  imageUrl: '/next-assets/images/cohort/athena-payless-superpower.svg',
  imageAlt: "ATHENA'S PAY LESS SUPERPOWERS",
  gridContent: [
    {
      title: 'Interest Only loan for a period',
      description:
        'Reduce your repayments by switching to our sharp interest only rates with no monthly fees. Free up your cashflow.',
    },
    {
      title: 'Debt consolidation',
      description: 'Move debts onto your home loan at a lower rate to save in repayments and interest.',
    },
    {
      title: 'No charge changes',
      description: 'We don’t charge you to make changes to your Straight Up or Power Up home loan. Unlike many others.',
    },
  ],
  quote: {
    author: 'Efthimios, Home Loan Wrecker',
    quote:
      '"I’m saving an average of $230 a month with Athena! AND NO FEES on anything! Honestly I wish I did this earlier!!”',
    isTrustPilot: true,
  },
};

export const SpeedAndEaseContent: Segment = {
  header: 'Switch with speed and ease',
  imageUrl: '/next-assets/images/cohort/athena-speedandease-superpower.svg',
  imageAlt: "ATHENA'S SPEED AND EASE SUPERPOWERS",
  gridContent: [
    {
      title: 'More speed, less docs',
      description:
        'Calculate your repayments and savings in 3 minutes. Apply online in 15 minutes. You may need as little as two payslips. ',
    },
    {
      title: 'Experts who are on your side',
      description: 'SMS, live chat or call your dedicated Aussie-based Loan Expert to get your deal done.',
    },
  ],
  quote: {
    author: 'Ken, Home Loan Wrecker',
    quote: '“Easily beat the Bank for speed and ease of application.”',
    isTrustPilot: true,
  },
};
